import { OptimizelyKey } from 'src/services/flags/utils/types';

export const defaultOptimizelyFlags = {
  localization_revamp: {
    enabled: false
  },
  web_free_trial: {
    enabled: false
  },
  avalara_tax: {
    enabled: false
  },
  registration_billing: {
    enabled: false
  },
  ai_notes_rewrite: {
    enabled: false
  },
  recaptcha_security: {
    enabled: false
  },
  recaptcha_security_signup: {
    enabled: false
  },
  ai_rewrite_email: {
    enabled: false
  },
  revenue_cat: {
    enabled: false
  },
  bookkeeping: {
    enabled: false
  },
  ai_generate_invoice: {
    enabled: false
  },
  ai_quick_estimate: {
    enabled: false
  },
  recurring_invoices_enabled: {
    enabled: false
  },
  payments_unbranded_upgrade_prompt: {
    enabled: false
  },
  payments_enabled: {
    enabled: false
  },
  paypal_v_stripe_variant: {
    enabled: false
  },
  web_trial7day: {
    enabled: false
  },
  einvoicing_receiving: {
    enabled: false
  },
  payable_estimate: {
    enabled: false
  }
} as const;

export const flagsToTrack: OptimizelyKey[] = [
  'localization_revamp',
  'registration_billing',
  'recaptcha_security',
  'recaptcha_security_signup',
  'web_trial7day',
  'bookkeeping'
];
